import React from 'react'

const Header = () => {
  return (
    <div>
      <h1 className='text-xl'>Wallet Spur</h1>
    </div>
  )
}

export default Header